<template>
    <button @click="handelInput" 
        :class="{
            active: active,
            pulse: pulse,
            disabled: disabled,
            'link-button': isLinkButton
            }"
        >{{label}}</button>
</template>

<script>

export default {
    name: "CButton",
    props: {
        label: {
            required: true,
            default: 'clickMe'
        },
        showActiveState: {
            default: false,
        },
        setActiveState: {
            default: false,
        },
        showPulse: {
            default: false,
        },
        disabled: {
            default: false,
        },
        type: {
            default: 'button'
        }
    },
    data: function(){
        return {
            active: false,
            pulse: false,
        }
    },
    computed: {
        isLinkButton() {
            return this.type == 'link-button';
        }
    },
    methods:{
        handelInput(){
            if(!this.disabled) {
                this.toggleState(!this.active)
                this.$emit('click', this.active);
            }
        },
        toggleState(newActive, overwriteDisabled){
            if(this.showActiveState && (!this.disabled || overwriteDisabled)) {
                this.active = newActive;                
                if(this.showPulse) {
                    this.pulse = this.active;
                }
            }
        }
    },
    watch: {
        setActiveState(){            
            this.toggleState(this.setActiveState, true);
        }
    },
    mounted() {        
        this.toggleState(this.setActiveState, true);
    }
}
</script>

<style lang="scss" scoped>

    @import "../../assets/styles/_globals";
    

    button {
        outline: none;
        height: 40px;
        font-weight: bold;
        font-size: 14px;
        border: solid 2px $seltec_color;
        cursor: pointer;
        background-color: transparent;
        color: #fff;
    }

    button:active {
        background-color: $sec_color_dark;
    }

    button.active {
        background-color: $seltec_color;
        color: $font-dark-color;
    }

    button.pulse {
        animation: pulseButton 2s infinite alternate;
    }

    .link-button {
        margin-right: 10px;
        background-color: transparent!important;
        border-color: transparent!important;
        color: #fff;
    }

    .disabled  {
        opacity: 0.5;
    }

    @keyframes pulseButton {
        0% {
            background-color: $seltec_color;
        }

        100% {
            background-color: $prim_warning_color;
        }  
    }

</style>